import { GameController } from "./GameController.ts";

export default class GameInteractionController {
    gameController: GameController;

    handleKeyDown = (event) => {
        if(event.key === 'e' || event.key === 'E') {
            this.gameController.sendEvent("player:interacted");
        } else if (event.key === 'p' || event.key === 'P') {
            this.gameController.sendEvent("player:position:requested");
        }
    };

    handleWheel = (event) => {
        if(event.deltaY > 0) {
            this.gameController.sendEvent("player:scrolled", {direction: 'down'});
        } else {
            this.gameController.sendEvent("player:scrolled", {direction: 'up'});
        }
    }

    constructor(gameController) {
        this.gameController = gameController;
        window.addEventListener('keydown', this.handleKeyDown);
        //wheel scroll detection
        window.addEventListener('wheel', this.handleWheel);
    }

    destroy() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }
    
}